import { Navigate, Route, Routes } from "react-router-dom"

import BackofficeIndex from "./index";
import BackofficeLayout from "./BackofficeLayout";
import Consultants from "./consultants";
import FailuresPage from "./failures";
import StepsPage from "./steps";
import BudgetPage from "./budget";
import NotificationUsers from "./budget/notification-users";
import SupportPage from "./support";
import MatrizPage from "./support/matriz";
import SubjectPage from "./support/subjects";
import SubtopicPage from "./support/subtopics";

const BackofficeRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<BackofficeIndex {...props} />} />
    <Route path="/consultants" element={
      <BackofficeLayout>
        <Consultants {...props} />
      </BackofficeLayout>
    } />
    <Route path="/failures" element={
      <BackofficeLayout>
        <FailuresPage {...props} />
      </BackofficeLayout>
    } />
    <Route path="/steps" element={
      <BackofficeLayout>
        <StepsPage {...props} />
      </BackofficeLayout>
    } />
    <Route path="/budget" element={<BudgetPage {...props} />}>
      <Route path="notification-users" element={<NotificationUsers />} />
    </Route>
    <Route path="/support" element={<SupportPage {...props} />}>
      <Route path="matriz" element={<MatrizPage />} />
      <Route path="subjects" element={<SubjectPage />} />
      <Route path="subtopics" element={<SubtopicPage />} />
    </Route>
  </Routes>
);

export default BackofficeRoutes;    